module.exports = __webpack_public_path__ + "img/reminder-comments.bddb2dfe.svg";